<template>
  <div class="header">
    <div class="topBar">
      <div class="auto">
        <span class="font-red" @click="openDeclaration"><a>郑重声明：严厉打击仿冒行为</a></span>
        <span>PC客服热线：021-20219997</span>
        <span>手机客服热线：021-20219990</span>
      </div>
    </div>
    <div class="nav">
      <div class="auto">
        <div class="navL">
          <span class="logo">
            <img :src="logoUrl" />
          </span>
        </div>
        <div class="loginBar">
          <a href="http://www.gw.com.cn" target="_blank">大智慧官网</a>
          <router-link :to="'/'">商城</router-link>
          <a v-if="userName">{{userName}}</a>
          <a @click="logout" v-if="userName">退出</a>
          <router-link :to="'/login'" v-if="!userName">登录</router-link>
          <a @click="register" v-if="!userName">注册</a>
          <router-link :to="'/personal/orderlist'">个人中心</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router/index.js";
export default {
  data() {
    return {
      logoUrl: require("@/assets/images/common/logo.png"),
      userName: this.$storage.getUserName()
    };
  },
  methods: {
    register() {
      this.$get("/user/register")
        .then(response => {
          if (response.code === 0) {
            window.location.href = response.data;
          } else {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    },
    logout() {
      this.$get("/user/logout")
        .then(response => {
          if (response.code === 0) {
            this.$storage.removeUserName();
            router.push("/login");
          } else {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    },
    openDeclaration(){
      window.open("https://www.gw.com.cn/declaration.shtml")
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/AppHeader.vue